export const environment = {
  production: false,
  baseUrlGaleryCompany:
    'https://api.test.wegestu.com/api/Company/file/gallery_company/',
  baseUrl: 'https://api.test.wegestu.com',
  baseUrlGalery: 'https://api.test.wegestu.com/api/User/file/gallery_users/',
  baseUrlGaleryCv: 'https://api.test.wegestu.com/api/User/file/gallery_cvs/',
};
